import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiMethod } from '../helper/apiconstant';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from '../environments/environment';
import { Commonservice } from './commonservice';

interface RequestCallOptions {
  suppressToast?: boolean;
  [key: string]: unknown;
}

@Injectable({
  providedIn: 'root'
})
export class Httpservice {

    public showHeader: boolean = false;
    childMenuId:any;
    reportsNavigation:string='';
    constructor(
      private readonly http: HttpClient,
      private readonly loaderSvc:NgxSpinnerService,
      private readonly commonSvc: Commonservice,
    ) {}

    

    requestCall(apiRoute: any, method: ApiMethod, data?: any, showSuccessToastr = false, options?: RequestCallOptions,): Observable<any> {
        const { suppressToast, ...httpOptions } = options ?? {};
        const shouldShowSuccessToastr = showSuccessToastr || method !== ApiMethod.GET;
        let response: any;
        switch (method) {
            
            case ApiMethod.GET:
                response = this.http.get(environment.apiBaseURL + apiRoute + (data ?? '')).pipe(
                  tap((result) => this.handleApiToast(result, suppressToast, shouldShowSuccessToastr)),
                  catchError((error) => this.handleError(error, suppressToast)),
                );
                break;
            case ApiMethod.POST:
                response = this.http.post(environment.apiBaseURL + apiRoute , data, httpOptions).pipe(
                  tap((result) => this.handleApiToast(result, suppressToast, shouldShowSuccessToastr)),
                  catchError((error) => this.handleError(error, suppressToast)),
                );
                break;
            case ApiMethod.PATCH:
                response = this.http.patch(environment.apiBaseURL + apiRoute, data, httpOptions).pipe(
                  tap((result) => this.handleApiToast(result, suppressToast, shouldShowSuccessToastr  )),
                  catchError((error) => this.handleError(error, suppressToast)),
                );
                break;
            case ApiMethod.DELETE:
                response = this.http.delete(environment.apiBaseURL + apiRoute, { body: data, ...httpOptions }).pipe(
                  tap((result) => this.handleApiToast(result, suppressToast, shouldShowSuccessToastr)),
                  catchError((error) => this.handleError(error, suppressToast)),
                );
                break;
            default:
                break;
        }

        return response;
    }

    handleError(error: any, suppressToast = false) {
        if (!suppressToast) {
            this.commonSvc.notifyApiError(error);
        }

        return throwError(() => error);
    }

    showLoader(){
        this.loaderSvc.show();
    }

    hideLoader(){
        this.loaderSvc.hide();
    }

    downloadfile(api: any, method: ApiMethod, data?: any, apitype?: boolean): Observable<any> {
        let BaseUrl = "";
        let response: any;

        BaseUrl = environment.apiBaseURL;

        const httpOptions = {
        responseType: "blob" as "json",
        };

        let getparam: any;

        if (data !== undefined) {
          if (typeof data === 'string' && data.trim().startsWith('?')) {
            getparam = data;
          } else {
            getparam = "/" + data;
          }
        } else {
          getparam = "";
        }


        switch (method) {
        case ApiMethod.GET:
            response = this.http.get(BaseUrl + api + getparam, httpOptions);
            break;
        case ApiMethod.POST:
            response = this.http.post(BaseUrl + api, data, httpOptions);
            break;
        case ApiMethod.PATCH:
            response = this.http.patch(BaseUrl + api, data, httpOptions);
            break;
        case ApiMethod.DELETE:
            response = this.http.delete(BaseUrl + api, { body: data, ...httpOptions });
            break;
        default:
            break;
        }

        return response;
    }

    private handleApiToast(response: unknown, suppressToast = false, showSuccessToastr = false): void {
        if (suppressToast) {
            return;
        }

        this.commonSvc.notifyApiResponse(response, 'Operation completed successfully', showSuccessToastr);
    }
}
